import styled from 'styled-components';
import { SIZE, LAYERS } from '../../common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { Label } from 'common/baseComponents';

export interface HoverContainerProps {
    editing?: boolean
}
export const InputIconFieldHoverContainer = styled.div`
    display: flex;
    flex:1;
    padding: ${SIZE.TWO}px 0;
    margin-right: 0px;
    border-radius: 10px;
    background-color: ${(props: HoverContainerProps) => props.editing && `#f1f5fb` };  
    
    &:hover {
        background-color: ${(props: HoverContainerProps) => !props.editing && `#f1f5fb` };  
    }
`;

export const InputIconFieldMainContainer = styled.div`
    display: flex;
    flex:1;
    justify-content: flex-start;
    padding-left: ${SIZE.ONE}px;
    margin-bottom: ${SIZE.TWO}px;
    margin-right: ${SIZE.ONE}px;
    button {
        height: ${SIZE.THREE}px;
        font-size: 14px;
        //padding: 0 ${SIZE.HALF}px;
        margin: 0 ${SIZE.HALF}px
    }
`;

export interface ButtonVisibilityProps {
    visibility?: boolean
}
export const ButtonVisibility = styled.div`
    button {
        visibility : ${(props: ButtonVisibilityProps) => props.visibility ? `visible` : `hidden`}; 
    }
`

export const LabelContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-flow: column;
    align-items: left;
    width: 100%;
`;

interface InputIconProps {
    showAlertIcon?: boolean;
}

export const LabelTitle = styled.div`
    color: #525252;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: bold;
    flex: ${(props: InputIconProps) => props.showAlertIcon ? 0 : 1};
    white-space: nowrap;
`;

export interface InputContainerProps {
    editable?: boolean
    padding?: string
    margin?: string
}
export const InputContainer = styled.div`
    box-shadow: ${(props: InputContainerProps) => props.editable ? `1px 1px 6px 1px rgba(0, 0, 0, 0.16)` : `none`}; 
    margin: ${(props: InputContainerProps) => props.margin}; 
    transition: all ease .300s;
`;

export const ActionContainer = styled.div`
    display:flex;
    align-items: center;
    margin-left: ${SIZE.ONE}px;
    // min-width: ${SIZE.TEN}px;
    // max-width: ${SIZE.FIFTEEN}px;
    & : hover {
        cursor: pointer;
    }
    button {
        //color: ${(props: InputContainerProps) => props.editable ? `#ff7319;` : `#707070;`}; 
    };
`

export const Input = styled.input`
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    color: #343434;
    outline: none;
    border: none;
    padding: ${SIZE.ONE}px;
    flex:1;
`

export const InputLabel = styled(Label)`
    color: #000000;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
`

export const IconContainer = styled.div`
    display: flex;
    width: ${SIZE.FIVE}px;
    margin: 0 ${SIZE.TWO}px 0 0 ;
`

export const IconErrorSyncContainer = styled.div`
    margin: 0px 0px 0px 10px;
    flex: 1;
    cursor: pointer;
    position: relative;
`;

export const ToolTipContainer = styled.div`
    position: absolute;
    top: 0px;
    left: 30px;
    z-index: 100;
    display: none;
    margin: 0px 0px 0px 0px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
    max-width: 200px;
    ${IconErrorSyncContainer}:hover & {
        display: flex;
    }
`;

export const ToolTipLabel = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
`;

export const ErrorMessageContainer = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #f46969;
    margin: 12px 0px 0px 55px;
`;

export const CharacterCountLine = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #2b3a66;
    padding: 14px 0px 0px 0px;
`;

interface LimitsProps {
    limitsAlert?: boolean;
}

export const CharacterLimitLine = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: ${(props: LimitsProps) => (props.limitsAlert ? '#b7332b' : '#bdbdbd')};
    padding: 10px 0px 0px 0px;
`;
